/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Review_IntroInputs */

const en_fc_home_review_intro = /** @type {(inputs: Fc_Home_Review_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A practical overview of the documented editing workflow, strengths and limits to consider before trying FilmCraft.`)
};

/**
* | output |
* | --- |
* | "A practical overview of the documented editing workflow, strengths and limits to consider before trying FilmCraft." |
*
* @param {Fc_Home_Review_IntroInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_review_intro = /** @type {((inputs?: Fc_Home_Review_IntroInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Review_IntroInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_review_intro(inputs)
});
export { fc_home_review_intro as "fc.home.review.intro" }